import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Flex, Box } from "@chakra-ui/react";
import time from "src/utils/time";
import { H4, BodyText2 } from "src/atoms/typography";
import CorrespondingAvatar from "src/modules/avatar/components/CorrespondingAvatar";

const UPDATE_PERIOD = 200;

export default function MonitoringInfo({ avatar, startDate }) {
  const [_, forceUpdate] = useState(new Date());
  const { t } = useTranslation();
  const intervalId = useRef(null);

  useEffect(() => {
    intervalId.current = setInterval(selfUpdater, UPDATE_PERIOD);
    return () => clearInterval(intervalId.current);
  }, []);

  const selfUpdater = () => {
    forceUpdate(new Date());
  };

  const duration = time.duration(time().diff(startDate));

  return (
    <Flex
      alignItems="center"
      p="12px"
      width="100%"
      borderRadius="31.5px"
      border="2px solid"
      borderColor="outline"
    >
      <Box mr="16px">
        <CorrespondingAvatar avatar={avatar} width="40px" height="40px" />
      </Box>
      <Box>
        <H4
          color="highEmphasis"
          maxWidth="120px"
          overflow="hidden"
          textOverflow="ellipsis"
          whiteSpace="nowrap"
        >
          {avatar ? avatar.name : t("avatar.myAvatar")}
        </H4>
        <BodyText2 color="mediumEmphasis">
          {duration.format("d _ h _ m _ s _", { largest: 2 })}
        </BodyText2>
      </Box>
    </Flex>
  );
}
